import { AVAILABILITY_OPTIONS, MEASURE, SORTING_DIRECTION } from 'src/constants/main';
import { ICaloriesValidation, ILangTextValidation, IPriceValidation, TBooleanInNumber, TTranslate } from 'src/types/main';

export interface IModifier {
  id: number;
  external_id?: string | number;
  name: TTranslate;
  status: TBooleanInNumber;
  is_delete: TBooleanInNumber;
  options: IModifierOption[];
  apply_price_in_linked_items?: TBooleanInNumber;
  apply_price_in_branches?: TBooleanInNumber;
  is_draft?: boolean;
}

export enum MODIFIERS_CHECKBOX {
  APPLY_PRICE_IN_BRANCHES = 'apply_price_in_branches',
  APPLY_PRICE_IN_LINKED_ITEMS = 'apply_price_in_linked_items',
}

export interface IModifierOption {
  id: number;
  external_id?: string | number;
  name: TTranslate;
  price: string; // float number
  calories: number | null;
  weight: string; // float number
  unit: MEASURE;
  taxable: TBooleanInNumber;
  is_delete: TBooleanInNumber;
}

export interface IModifiersFilters {
  search: string;
  availability: AVAILABILITY_OPTIONS | undefined;
  sort_field: MODIFIERS_COLUMN_NAME;
  sort_dir: SORTING_DIRECTION;
}

export enum MODIFIERS_COLUMN_NAME {
  NAME = 'name',
}

export interface IModifierOptionValidation {
  id: string | number;
  name: ILangTextValidation;
  price: IPriceValidation;
  calories: ICaloriesValidation;
}

export interface IModifierValidation {
  valid: boolean;
  name: ILangTextValidation;
  options: IModifierOptionValidation[];
}
